export default {
  SELECT_CONVERSATION: 'SELECT_CONVERSATION',
  DESELECT_CONVERSATION: 'DESELECT_CONVERSATION',
  REORDER: 'RECEIVE_AND_REORDER_CONVERSATIONS',
  REPLACE: 'RECEIVE_AND_REPLACE_CONVERSATION',
  RECEIVE_NEW_PAGE: 'RECEIVE_NEW_PAGE',
  REMOVE: 'REMOVE_CONVERSATION',
  REQUESTING: 'LOADING_ACTIVE_CONVERSATION',
  ERROR: 'ACTIVE_CONVERSATION_ERROR'
};
